import { supabase } from './supabase'

/**
 * The Shortcut's key.
 *
 * iOS gives a PWA no Share Sheet target, so a PDF sitting in Mail has no way
 * into the app. An Apple Shortcut does appear in the Share Sheet, and this is
 * what lets it prove who it belongs to.
 */

export interface IngestKey {
  id: string
  key: string
  label: string
  lastUsedAt: string | null
  createdAt: string
}

export const INGEST_URL =
  `${import.meta.env.VITE_SUPABASE_URL ?? ''}/functions/v1/ingest`.replace(/^\/+/, '')

export async function loadIngestKeys(): Promise<IngestKey[]> {
  const { data, error } = await supabase
    .from('ingest_keys')
    .select('id, key, label, last_used_at, created_at')
    .order('created_at')
  if (error) throw error
  return (data ?? []).map((k) => ({
    id: k.id as string,
    key: k.key as string,
    label: k.label as string,
    lastUsedAt: (k.last_used_at as string) ?? null,
    createdAt: k.created_at as string,
  }))
}

export async function issueIngestKey(label = 'iPhone'): Promise<string> {
  const { data, error } = await supabase.rpc('issue_ingest_key', { p_label: label })
  if (error) throw error
  return data as string
}

export async function revokeIngestKey(id: string): Promise<void> {
  const { error } = await supabase
    .from('ingest_keys')
    .update({ revoked_at: new Date().toISOString() })
    .eq('id', id)
  if (error) throw error
}

/** "vandaag", "3 dagen geleden", or that it has never been used. */
export function describeLastUsed(iso: string | null): string {
  if (!iso) return 'nog niet gebruikt'
  const days = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000)
  if (days === 0) return 'vandaag gebruikt'
  if (days === 1) return 'gisteren gebruikt'
  if (days < 30) return `${days} dagen geleden gebruikt`
  return 'lang niet gebruikt'
}
